module.exports = __webpack_public_path__ + "static/img/18.8c74c7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/18.jpg
// module id = AguM
// module chunks = 0